var map = {
	"./boomstam-1.jpeg": 381,
	"./boomstam-2.jpeg": 382,
	"./ijs-tapas-1.jpeg": 383,
	"./ijs-tapas-2.jpeg": 384,
	"./kerstman-door-het-ijs-1.jpeg": 385,
	"./kerstman-door-het-ijs-2.jpeg": 386,
	"./kerstman-door-het-ijs-3.jpeg": 387,
	"./kerstman-door-het-ijs-4.jpeg": 388,
	"./kerstman-red-velvet-1.jpeg": 389,
	"./kerstman-red-velvet-2.jpeg": 390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;